import React, { useState } from "react";
import { apiCall } from "../../utils/Api"
import { Button, Divider, Modal, Popconfirm, Space, Table, Tooltip, Row, Col, Form, Select, Input, Spin, message } from "antd";
import { HistoryOutlined, CheckCircleFilled, CloseCircleFilled, ImportOutlined, QuestionCircleOutlined } from '@ant-design/icons';
import { EyeSlashIcon, EyeIcon } from "../../admin/Icons";

export default function TrashedMenus(props) {


    const { menus = [], nav = [], setNav = () => { }, parseMenu = () => { }, setMenus = () => { } } = props;
    const [loading, setLoading] = useState(false);
    const [visible, setVisible] = useState(false);
    const [trashed, setTrashed] = useState();
    const [warn, setWarn] = useState("");
    const [selected, setSelected] = useState(false)
    const [form] = Form.useForm();



    const updateMenu = (_obj) => {

        apiCall("site_content/updateMenu", _obj, (_status, _result) => {
            if (_status) {
                setMenus(_result);
                message.success("Menu recovered successfully.")
                close();
            } else {
                message.error(_result.error);
            }
        })

    }


    const close = () =>{
        setVisible(false);
        setSelected(false);
    }


    const restoreMenu = (_f) => {

        let _item = {};
        _item.name = _f.name;
        if (_f.parent_id) {
            _item.parent_id = _f.parent_id;
        }

        _item.visibility = _f.visibility;
        _item.menu_id = selected.id;
        _item.url = selected.url;
        _item.new_tab = selected.new_tab;
        _item.order = 0;
        updateMenu(_item);

    }

    const selectPage = (_item = selected) => {
        setSelected(_item);
        form.setFieldsValue({ "name": _item.name });
        form.setFieldsValue({ "visibility": _item.visibility });
    }

    const deleteMenu = (_item = selected) => {
        apiCall("site_content/deleteMenu", { menu_id: _item.id }, (_status, _result) => {
            if (_status) {
                message.success("Menu deleted successfully.");
                setTrashed(_result);
                setSelected(false)
            } else {
                message.error(_result.error);
            }
        })
    }




    const parseMenus = () => {

        let _menus = menus.filter(item => !item.parent_id);

        _menus = _menus.map(item => {
            return {
                value: item.id,
                label: item.name,
                has_content: item.has_content
            }
        });

        _menus.unshift({
            value: 0,
            label: "Root",
            has_content: false
        })

        return _menus;

    }

    const getTrashed = () => {
        setLoading(true)
        apiCall("site_content/getTrashedMenus", {}, (_status, _result) => {
            if (_status) {
                setTrashed(_result);
                setVisible(true);
                setLoading(false)
            }
        });
    }

    const columns = [
        { title: <small>Name</small>, dataIndex: "name", key: "name" },
        {
            title: <small><nobr>Active</nobr></small>, width: 46, dataIndex: "has_content", key: "has_content", render: (e) => {
                return (e) ? <div style={{ "textAlign": "center" }}><CheckCircleFilled style={{ "color": "#52c41a" }} /></div> : <div style={{ "textAlign": "center" }}><CloseCircleFilled style={{ "color": "#ff4d4f" }} /></div>
            }
        },
        {
            title: <small><nobr>Content</nobr></small>, width: 57, dataIndex: "has_content", key: "has_content", render: (e) => {
                return (e) ? <div style={{ "textAlign": "center" }}><CheckCircleFilled style={{ "color": "#52c41a" }} /></div> : <div style={{ "textAlign": "center" }}><CloseCircleFilled style={{ "color": "#ff4d4f" }} /></div>
            }
        },
        {
            title: <small>Actions</small>, width: 115, dataIndex: "actions", key: "actions", render: (e, f) => {

                return (
                    <Space>
                        <Popconfirm title="Are you sure?" onConfirm={() => deleteMenu(f)}><Button type="primary" size="small" danger><small>Delete</small></Button></Popconfirm>
                        <Button onClick={() => selectPage(f)} type="primary" size="small"><small>Select</small></Button>
                    </Space>
                )
            }
        },
    ]

    const rowClassName = (record) => {
        return record.id === selected?.id ? 'ant-table-row-selected' : '';
    };

    const drawForm = () => {

        return (
            <>
                <strong>Recover trashed menus</strong>
                <div className="shim" /><div className="shim" /><div className="shim" />
                <Table rowKey={"id"} rowClassName={rowClassName} pagination={false} style={{ "border": "1px solid #eee" }} scroll={{ y: 201 }} size="small" columns={columns} dataSource={trashed} />

                <Divider />

                <Form onFinish={(_f) => restoreMenu(_f)} form={form} layout="vertical">
                    <Spin indicator={<></>} spinning={!selected}>
                        <Row gutter={30}>
                            <Col span={16}>
                                <Form.Item name="name" rules={[{ required: true, message: "Name required" }]} label="Name">
                                    <Input placeholder="Name..." />
                                </Form.Item>
                                <Form.Item initialValue={0} name="parent_id" label="Parent">
                                    <Select onChange={(e, f) => setWarn((f.has_content) ? f.label : "")} options={parseMenus()} />
                                </Form.Item>
                            </Col>

                            <Col span={8}>
                                <Form.Item name="visibility" label={<Tooltip title={<>
                                    <nobr><strong>Draft:</strong> -  Inaccessible </nobr><br />
                                    <nobr><strong>Visible:</strong> - Accessed on menu / URL</nobr><br />
                                    <nobr><strong>Unlisted:</strong> - Accessed solely via URL</nobr><br />
                                </>}><div style={{ "cursor": "pointer" }}>Visibility? <QuestionCircleOutlined style={{ "color": "#aaa", "fontSize": "11px" }} /></div></Tooltip>}>
                                    <Select style={{ "width": "100%" }}>
                                        <Select.Option value="test"><div style={{ "color": "#e77e21", "display": "flex", "alignItems": "center" }}><EyeSlashIcon style={{ "color": "#e77e21" }} />&nbsp; Draft</div></Select.Option>
                                        <Select.Option value="visible"><div style={{ "color": "#3c8617", "display": "flex", "alignItems": "center" }}><EyeIcon style={{ "color": "#3c8617" }} />&nbsp; Visible</div></Select.Option>
                                        <Select.Option value="hidden"><div style={{ "color": "#aa119d", "display": "flex", "alignItems": "center" }}><EyeIcon style={{ "color": "#aa119d" }} />&nbsp; Unlisted</div></Select.Option>
                                    </Select>
                                </Form.Item>

                            </Col>
                        </Row>
                    </Spin>
                    {(warn && <div style={{ "color": "#ff4d4f", "textAlign": "center" }}>
                        Heads up, the menu <strong>{warn}</strong> you are putting this under has content. That content will become inaccessible on the customer site.<div className="shim" /><div className="shim" /><div className="shim" />
                    </div>)}

                    <Divider style={{ "margin": "0px 0px" }} />
                    <div className="shim" /><div className="shim" /><div className="shim" /><div className="shim" />

                    <div className="float-flex">
                        <Button>Cancel</Button>
                        <Space>
                            <Popconfirm onConfirm={() => deleteMenu(selected)} okText="Delete" okType="danger" title="Are you sure?"><Button disabled={!selected} danger type="primary" >Delete</Button></Popconfirm>
                            <Button disabled={!selected} htmlType="submit" type="primary">Recover</Button>
                        </Space>
                    </div>
                </Form>


            </>
        )

    }

    return (
        <>
            <Modal destroyOnClose footer={null} onCancel={() => close()} open={visible}>
                {drawForm()}
            </Modal>
            <Divider style={{ "margin": "15px 0px" }} />
            <Button loading={loading} type="primary" block onClick={() => getTrashed()} size="small"><small>Recover Trashed Menus</small></Button>


        </>
    )
}